import React, { useEffect, useRef, useState } from "react";
import styles from "./Leaderboard.module.css";
import { LeaderboardHeader } from "./LeaderboardHeader";
import { LeaderboardRow } from "./LeaderboardRow";
import { LeaderboardData, LeaderboardItem, UserPosition } from "../../interfaces/LeaderboardTypes";
import _isEmpty from "lodash/isEmpty";
import Loader from "../../components/Loader";
export interface LeaderboardProps {
  data: LeaderboardData;
  isLoading : any
  refetch : ()=>void
}

export const Leaderboard: React.FC<LeaderboardProps> = ({ data ,isLoading,refetch}) => {
  const { mainLeaderboard, userPositions } = data;
  const {nextOffsetToken} = data?.mainLeaderboard;
  const containerRef = useRef<HTMLDivElement | null>(null);
  const listData = [
    ...(userPositions || []),
    ...(mainLeaderboard?.items || []),
  ];
  const [mergedData, setMergedData] = useState<any[]>([]);
  const merge = () => {
    setMergedData((prevData) => { 
      const newItems = listData.filter((item : any) =>{
        const temp=!prevData.some((existingItem) => existingItem.zupeeUserId === item.zupeeUserId);
        return temp});
      return [
      ...prevData, 
      ...(newItems)
    ]});
  };
  console.log("listDatalistData", listData);
  const handleScroll = () => {
    if (!containerRef?.current || isLoading || !(nextOffsetToken)){
      return;
    }
    const bottom = containerRef.current.scrollHeight === containerRef.current.scrollTop + containerRef.current.clientHeight;
    if (bottom) {
      console.log("hello");
      refetch();
    }
  };
  useEffect(() => {
    const currentRef = containerRef.current;
    
    if (currentRef) {
      currentRef.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(()=>{
    merge();
  },[data])
  return (
    <>
      <div  className={styles.leaderboard}>
        <div ref={containerRef} onScroll={handleScroll} className={styles.leaderboardContent}>
          <LeaderboardHeader columns={["RANK", "NAME", "SCORE"]} />
          {mergedData?.map((entry, index) => (
            <LeaderboardRow
              key={`${entry?.rank}-${entry?.zupeeUserId}`}
              entry={entry}
              highlighted={entry?.userFullName === "You" ? true : false}
              rowNumber={index}
            />
          ))}
          {isLoading && <Loader transparent/>}
        </div>
      </div>
    </>
  );
};
